<template>
  <generic-modal :title="$t('billing log')" ref="generic_modal" :is_wide="true">
    <div class="container">
      <div class="timeline">
        <header class="timeline-header">
          <span class="tag is-medium is-primary">{{ $t("start") }}</span>
        </header>
        <div class="timeline-item pb-0" v-for="(log, lidx) in logs" :key="lidx">
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <p class="heading">{{ format_date_time(log.date) }}</p>
            <p>{{ log.message }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>{{ meta }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
        v-bind:class="{ 'is-loading': loading }"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button> -->
      <button class="button is-rounded is-danger" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
  format_date_time,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import handlebars from "handlebars";

export default {
  name: "BillingLogModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: {},
      logs: [],
      error: "",
    };
  },
  computed: {},
  methods: {
    format_date_time,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(billing_uuid) {
      let v = this;
      v.set_initial_state();

      get("/fel/bill/log", { uuid: billing_uuid })
        .then((logs) => {
          v.logs = logs;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });

      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = { customer: {} };
      v.logs = [];
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
